import { StoreDictionary } from 'src/tpbp-json-api-handler/utils/StoreDictionary/StoreDictionary'

export const recordStore = new StoreDictionary()

export function removeRecordFromCache(record: { $type: string; id: string }) {
  recordStore.delete(record.$type, record.id)
}

export function getRecord<Type = any>(objectType: string, id: string) {
  return recordStore.get<Type>(objectType, id)
}
